<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-size-100"
      style="margin-left: 15px; display: flex"
    >
      <div class="md-layout-item md-size-50">
        <user-avatar
          :title="userName"
          :sub-title="dataSourceId"
          :image="userAvatar"
        />
      </div>
      <div class="activity-overall-badges md-layout-item md-size-50">
        <div
          v-for="badge in badges"
          :key="badge._id"
          class="my-badges"
        >
          <img :src="badge.icon">
        </div>
      </div>
    </div>

    <div
      class="md-layout-item md-size-100"
      style="display: flex; margin-left: 15px !important;"
    >
      <i :class="[{ [formatActivityIcon(activityType)]: true, 'faIcon': true }]" />
      <div class="activity-type-info">
        <span class="activity-title">{{ activityTitle }}</span>
        <span class="activity-start-date">{{ formatDate(activityStart, true) }}</span>
      </div>
    </div>

    <div class="content">
      <div
        v-if="distanceInMeters && distanceInMeters.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="distanceInMeters" />
      </div>

      <div
        v-if="duration && duration.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="duration" />
      </div>

      <div
        v-if="averageSpeedInMetersPerSecond && averageSpeedInMetersPerSecond.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averageSpeedInMetersPerSecond" />
      </div>

      <div
        v-if="maxSpeedInMetersPerSecond && maxSpeedInMetersPerSecond.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="maxSpeedInMetersPerSecond" />
      </div>

      <div
        v-if="averagePaceInMinutesPerKilometer && averagePaceInMinutesPerKilometer.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averagePaceInMinutesPerKilometer" />
      </div>

      <div
        v-if="maxPaceInMinutesPerKilometer && maxPaceInMinutesPerKilometer.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="maxPaceInMinutesPerKilometer" />
      </div>

      <div
        v-if="averageRunCadenceInStepsPerMinute && averageRunCadenceInStepsPerMinute.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averageRunCadenceInStepsPerMinute" />
      </div>
      <div
        v-if="maxRunCadenceInStepsPerMinute && maxRunCadenceInStepsPerMinute.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="maxRunCadenceInStepsPerMinute" />
      </div>

      <div
        v-if="averageHeartrate && averageHeartrate.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averageHeartrate" />
      </div>

      <div
        v-if="elevation && elevation.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="elevation" />
      </div>

      <div
        v-if="caloriesBurned && caloriesBurned.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="caloriesBurned" />
      </div>

      <div
        v-if="averageBikeCadenceInRoundsPerMinute && averageBikeCadenceInRoundsPerMinute.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averageBikeCadenceInRoundsPerMinute" />
      </div>

      <div
        v-if="maxBikeCadenceInRoundsPerMinute && maxBikeCadenceInRoundsPerMinute.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="maxBikeCadenceInRoundsPerMinute" />
      </div>

      <div
        v-if="averageSwimCadenceInStrokesPerMinute && averageSwimCadenceInStrokesPerMinute.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="averageSwimCadenceInStrokesPerMinute" />
      </div>

      <div
        v-if="steps && steps.value"
        class="md-layout-item md-size-33 md-large-size-33 md-medium-size-50 md-small-size-100"
      >
        <activity-info :activity="steps" />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityInfo from './../atoms/activity-info';
import UserAvatar from './../atoms/user-avatar';
import datetime from "../../utils/datetime";
import activity from "../../utils/activity";

export default {
  name: 'ActivityOverallInfo',
  components: { ActivityInfo, UserAvatar },
  props: {
    activity: {
      type: Object,
    },
    userName: {
      type: String,
    },
    userAvatar: {
      type: String,
    },
    activityType: {
      type: Number,
    },
    activityStart: {
      type: String,
    },
    activityTitle: {
      type: String,
    },
    externalDataSourceId: {
      type: Number,
    },
    durationInSeconds: {
      type: Number,
    },
    badges: {
      type: Array,
    },
  },
  data() {
    return {
      dataSourceId: null,
      distanceInMeters: {},
      averageSpeedInMetersPerSecond: {},
      averageHeartrate: {},
      caloriesBurned: {},
      elevation: {},
      averagePaceInMinutesPerKilometer: {},
      duration: {},
      maxSpeedInMetersPerSecond: {},
      maxPaceInMinutesPerKilometer: {},
      averageRunCadenceInStepsPerMinute: {},
      maxRunCadenceInStepsPerMinute: {},
      averageBikeCadenceInRoundsPerMinute: {},
      maxBikeCadenceInRoundsPerMinute: {},
      averageSwimCadenceInStrokesPerMinute: {},
      steps: {},
    }
  },
  methods: {
    ...datetime,
    ...activity,
    formatActivityIcon: activityType => {
      const icons = {
        1: "far fa-running",
        2: "fas fa-walking",
        3: "far fa-biking",
        4: "far fa-swimmer",
        5: "far fa-dumbbell"
      };
      return icons[activityType] ? icons[activityType] : "fas fa-watch-fitness";
    },
  },
  beforeMount() {
    this.dataSourceId = this.getExternalSourceById(this.externalDataSourceId)
    if (this.activity.distanceInMeters) {
      this.distanceInMeters.title = 'Distance';
      this.distanceInMeters.value = (this.activity.distanceInMeters / 1000).toString().slice(0, 4);
      this.distanceInMeters.parameter = 'km';
      this.distanceInMeters.image = '/img/activity-data-icons/distance.svg';
    }
    if (this.activity.averageSpeedInMetersPerSecond) {
      this.averageSpeedInMetersPerSecond.title = 'Geschwindigkeit';
      this.averageSpeedInMetersPerSecond.value = this.formatSpeed(this.activity.averageSpeedInMetersPerSecond, '');
      this.averageSpeedInMetersPerSecond.parameter = '/km'
      this.averageSpeedInMetersPerSecond.image = '/img/activity-data-icons/pace.svg';
    }
    if (this.activity.maxSpeedInMetersPerSecond) {
      this.maxSpeedInMetersPerSecond.title = 'Max Geschwindigkeit';
      this.maxSpeedInMetersPerSecond.value = this.formatSpeed(this.activity.maxSpeedInMetersPerSecond, '');
      this.maxSpeedInMetersPerSecond.parameter = '/km'
      this.maxSpeedInMetersPerSecond.image = '/img/activity-data-icons/pace.svg';
    }
    if (this.activity.averagePaceInMinutesPerKilometer) {
      this.averagePaceInMinutesPerKilometer.title = 'Tempo';
      this.averagePaceInMinutesPerKilometer.value = this.formatPace(this.activity.averagePaceInMinutesPerKilometer, '');
      this.averagePaceInMinutesPerKilometer.parameter = '/km'
      this.averagePaceInMinutesPerKilometer.image = '/img/activity-data-icons/pace.svg';
    }
    if (this.activity.maxPaceInMinutesPerKilometer) {
      this.maxPaceInMinutesPerKilometer.title = 'Max Tempo';
      this.maxPaceInMinutesPerKilometer.value = this.formatPace(this.activity.maxPaceInMinutesPerKilometer, '');
      this.maxPaceInMinutesPerKilometer.parameter = '/km'
      this.maxPaceInMinutesPerKilometer.image = '/img/activity-data-icons/pace.svg';
    }
    if (this.activity.averageHeartrate) {
      this.averageHeartrate.title = 'Heart rate';
      this.averageHeartrate.value = this.activity.averageHeartRateInBeatsPerMinute;
      this.averageHeartrate.parameter = 'bpm';
      this.averageHeartrate.image = '/img/activity-data-icons/heart.svg';
    }
    if (this.activity.calories) {
      this.elevation.title = 'Elevation';
      this.elevation.value = this.activity.totalElevationGainInMeters;
      this.elevation.parameter = 'm';
      this.elevation.image = '/img/activity-data-icons/elevation.svg';
    }
    if (this.activity.calories) {
      this.caloriesBurned.title = 'Burned';
      this.caloriesBurned.value = this.activity.calories;
      this.caloriesBurned.parameter = 'kcal';
      this.caloriesBurned.image = '/img/activity-data-icons/fire.svg';
    }
    if (this.activity.averageRunCadenceInStepsPerMinute) {
      this.averageRunCadenceInStepsPerMinute.title = 'AVG Kadenz';
      this.averageRunCadenceInStepsPerMinute.value = this.activity.averageRunCadenceInStepsPerMinute.toFixed(2);
      this.averageRunCadenceInStepsPerMinute.parameter = 'kcal';
      this.averageRunCadenceInStepsPerMinute.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.activity.maxRunCadenceInStepsPerMinute) {
      this.maxRunCadenceInStepsPerMinute.title = 'Max Kadenz';
      this.maxRunCadenceInStepsPerMinute.value = this.activity.maxRunCadenceInStepsPerMinute.toFixed(2);
      this.maxRunCadenceInStepsPerMinute.parameter = 'kcal';
      this.maxRunCadenceInStepsPerMinute.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.activity.averageBikeCadenceInRoundsPerMinute) {
      this.averageBikeCadenceInRoundsPerMinute.title = 'AVG Kadenz';
      this.averageBikeCadenceInRoundsPerMinute.value = this.activity.averageBikeCadenceInRoundsPerMinute.toFixed(2);
      this.averageBikeCadenceInRoundsPerMinute.parameter = 'kcal';
      this.averageBikeCadenceInRoundsPerMinute.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.activity.maxBikeCadenceInRoundsPerMinute) {
      this.maxBikeCadenceInRoundsPerMinute.title = 'Max Kadenz';
      this.maxBikeCadenceInRoundsPerMinute.value = this.activity.maxBikeCadenceInRoundsPerMinute.toFixed(2);
      this.maxBikeCadenceInRoundsPerMinute.parameter = 'kcal';
      this.maxBikeCadenceInRoundsPerMinute.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.activity.averageSwimCadenceInStrokesPerMinute) {
      this.averageSwimCadenceInStrokesPerMinute.title = 'Max Kadenz';
      this.averageSwimCadenceInStrokesPerMinute.value = this.activity.averageSwimCadenceInStrokesPerMinute.toFixed(2);
      this.averageSwimCadenceInStrokesPerMinute.parameter = 'kcal';
      this.averageSwimCadenceInStrokesPerMinute.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.activity.steps) {
      this.steps.title = 'Schritte';
      this.steps.value = this.activity.steps;
      this.steps.parameter = 'kcal';
      this.steps.image = '/img/activity-data-icons/fire.svg'; //Missing icon
    }
    if (this.durationInSeconds) {
      this.duration.title = 'Duration';
      this.duration.value = this.formatS2M(this.durationInSeconds);
      this.duration.image = '/img/activity-data-icons/duration.svg';
    }
  }
}
</script>

<style scoped lang="scss">
:host {
  display: block;
  .details {
    display: flex;
    flex-direction: column;
  }
}
.content {
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 15px;
  .md-layout-item {
    margin-top: 10px;
  }
}

.activity-overall-badges {
  display: flex;
  flex-direction: row-reverse;
  .my-badges {
    width: 40px;
    height: 40px;
    margin-left: 5px;
  }
}
.faIcon {
  font-size: 20px;
  display: flex;
  margin-right: 36px;
  padding-top: 4px
}

.activity-type-info {
  display: flex;
  flex-direction: column;
}

.activity-title {
  font-size: 20px;
  font-weight: 500;
}
.activity-start-date {
  font-size: 12px;
  font-weight: 400;
}
</style>
